import { render, staticRenderFns } from "./TemplateMessageList.vue?vue&type=template&id=a5649188"
import script from "./TemplateMessageList.vue?vue&type=script&lang=js"
export * from "./TemplateMessageList.vue?vue&type=script&lang=js"
import style0 from "./TemplateMessageList.vue?vue&type=style&index=0&id=a5649188&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports